import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpError, SessionStorageKey } from '../../shared/models/constants'
import { AuthenticationService } from '../authentication/authentication.service';
import { HelperService } from '../../shared/services/helper.service';
import { GlobalObjectsService } from '../../shared/services/global-objects.service';
import { CommonService } from '../services';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  baseUrl: string;
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly helperService: HelperService,
    private readonly globalObjectsService: GlobalObjectsService,
    private readonly commonService: CommonService,
    private readonly router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if ([HttpError.Unauthorized, HttpError.Forbidden].includes(err.status) && this.authenticationService.isLogin) {
        // auto logout if 401 or 403 response returned from api
        this.baseUrl = this.helperService.getBaseUrl();
        this.authenticationService.logout().subscribe(() => {
          if (!this.helperService.AllowAnonymousAccess()) {
            this.helperService.isTimeout = true;
            this.helperService.narBarCollapseState.next(true);
            const isFromMobileApp = sessionStorage.getItem(SessionStorageKey.IsFromMobileApp) === 'true';
            if (isFromMobileApp) {
              this.router.navigate([this.baseUrl + '/login'], { queryParams: { timestamp: Date.now(), manualLogout: true } });
            } else {
              this.router.navigate([this.baseUrl + '/login']);
            }
            this.globalObjectsService.logoutProfile = true;
            this.commonService.logoutInProgress = false;
          }
          else {
            this.router.navigate([this.baseUrl + '/']);
            this.globalObjectsService.logoutProfile = true;
            this.globalObjectsService.showClientLogo.next(false);
          }
        });
      }
      if ([HttpError.Unauthorized].includes(err.status) && !this.authenticationService.isLogin) {
        // auto logout if 401 or 403 response returned from api
        //sessionStorage.removeItem("currentGuest");

      }
      if ([HttpError.Forbidden].includes(err.status) && sessionStorage.getItem(SessionStorageKey.MfaTempUser) != null) {
        window.location.reload();

      }
      //  if (err.status == HttpError.NotFound) {
      //   window.location.href = '/';
      //  }
      if (err.status == HttpError.InternalServerError) {

      }
      console.log(err);
      return throwError(err);
    }))
  }
}
